import type { BusinessType } from "@hellocashflow/domain";

interface SplitBusinessTypesResult {
  activeTypes: BusinessType[];
  inactiveTypes: BusinessType[];
}

export const splitBusinessTypesByStatus = (
  businessTypes: BusinessType[] | undefined,
): SplitBusinessTypesResult => {
  const allTypes = businessTypes ?? [];

  return {
    activeTypes: allTypes.filter((item) => item.isActive),
    inactiveTypes: allTypes.filter((item) => !item.isActive),
  };
};

export const normalizeBusinessTypeLabel = (label: string): string =>
  label.trim();

export const hasActiveBusinessTypeLabelConflict = (
  label: string,
  activeTypes: BusinessType[],
  excludeId?: string,
): boolean => {
  const canonicalLabel = normalizeBusinessTypeLabel(label).toLowerCase();

  return activeTypes.some(
    (item) =>
      item.id !== excludeId &&
      normalizeBusinessTypeLabel(item.label).toLowerCase() === canonicalLabel,
  );
};
